export default "__VITE_ASSET__D_uj_kar__"